import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';

const InvoiceLoadingOverlay = ({ isLoading, message }) => {
  return (
    <Modal show={isLoading} centered backdrop="static" keyboard={false} size="sm">
      <Modal.Body className="text-center py-4">
        <Spinner animation="border" role="status" style={{ width: '2.5rem', height: '2.5rem', color: '#00a8ff' }}>
          <span className="sr-only">Loading...</span>
        </Spinner>
        {message && <p className="mt-3 mb-0 text-muted">{message}</p>}
      </Modal.Body>
    </Modal>
  );
};

export default InvoiceLoadingOverlay;
